import React from 'react';
import TouchableOpacityWithMiddleClick from './TouchableOpacityWithMiddleClick';
import MyAppText from './MyAppText';
import { Hoverable } from 'react-native-web-hover';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface LinkProps {
    text: string;
    textColor?: string;
    fontSize?: number;
    icon?: IconDefinition;
    onPress: () => (void | Promise<void>);
    onMiddleClick?: () => (void | Promise<void>);
}

export default function Link(props: LinkProps) {
    const { styles, theme } = useStyles(stylesheet);

    return <TouchableOpacityWithMiddleClick
        onPress={props.onPress}
        onMiddleClick={props.onMiddleClick}
    >
        <Hoverable style={{
            flexDirection: 'row',
            columnGap: 5,
            alignItems: 'center',
        }}>
            {({ hovered }) => (<>

                {props.icon ?
                    <FontAwesomeIcon icon={props.icon} width={14} color={hovered ? theme.colors.tabs.selected : (props.textColor ?? theme.colors.textColor)} />
                    : null
                }
                <MyAppText style={styles.text(hovered, props.textColor, props.fontSize)}>{props.text}</MyAppText>
            </>)}
        </Hoverable>
    </TouchableOpacityWithMiddleClick>;
}

const stylesheet = createStyleSheet(theme => ({
    text: (hovered: boolean, textColor?: string, fontSize?: number) => ({
        textDecorationLine: 'underline',
        color: hovered ? theme.colors.tabs.selected : (textColor ?? theme.colors.textColor),
        whiteSpace: 'nowrap',
        fontSize: fontSize ?? 14,
    }),
}));
